export default `.ids-tabs-container {
  --tab-width: 100%;
  --vertical-container-width: 250px;
  --more-tab-space-right: 45px;
  --more-tab-space-rtl-left: 45px;
  --ids-swappable-item-padding-block: 0;
  --ids-swappable-item-height: var(--ids-tab-height);
  --ids-swappable-item-icon-margin-inline: -4px -15px;
  display: flex;
  position: relative;
}
.ids-tabs-container.is-scrolled-left::before, .ids-tabs-container.is-scrolled-right::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background-image: var(--ids-tab-overflow-effect-left);
  height: 100%;
  width: 40px;
  pointer-events: none;
  z-index: 1;
}
.ids-tabs-container.is-scrolled-left.rtl::before, .ids-tabs-container.is-scrolled-right.rtl::after {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-start: unset;
  inset-inline-end: 0;
}
.ids-tabs-container.is-scrolled-right::after {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-start: unset;
  inset-inline-end: 0;
}
.ids-tabs-container.hide-headers {
  display: none;
}
.ids-tabs-container.is-scrolled-right.rtl::after {
  background-image: var(--ids-tab-overflow-effect-left);
}
.ids-tabs-container.is-scrolled-left.rtl::before {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-start: 0;
  inset-inline-end: unset;
}
.ids-tabs-container.has-more-actions.is-scrolled-right::after {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-end: 42px;
  inset-inline-start: unset;
  top: 0;
}
.ids-tabs-container.has-more-actions.is-scrolled-right.rtl::after {
  background-image: var(--ids-tab-overflow-effect-left);
}
.ids-tabs-container.color-variant-module.is-scrolled-left::before {
  top: 0;
  left: 0;
  height: var(--ids-tab-module-height);
}
.ids-tabs-container.has-app-menu.color-variant-module.is-scrolled-left::before {
  left: var(--ids-tab-more-button-width);
}
.ids-tabs-container.color-variant-module.has-more-actions.is-scrolled-right::after {
  right: var(--more-tab-space-right);
  left: unset;
  top: 0;
  height: var(--ids-tab-module-height);
}
.ids-tabs-container.color-variant-module.has-more-actions.rtl.is-scrolled-left::before {
  inset-inline-end: 0;
}
.ids-tabs-container.color-variant-module.rtl.is-scrolled-left::before {
  height: var(--ids-tab-module-height);
  inset-inline-end: 44px;
}
.ids-tabs-container.color-variant-module.has-more-actions.rtl.is-scrolled-right::after {
  left: var(--more-tab-space-rtl-left);
  right: unset;
  top: 0;
}
.ids-tabs-container.color-variant-header.is-scrolled-right::after {
  right: 94px;
  top: 0;
}
.ids-tabs-container.color-variant-header.is-scrolled-left::before {
  top: 0;
}
.ids-tabs-container.color-variant-header.rtl.is-scrolled-right::after {
  left: 94px;
  right: unset;
  top: 0;
}
.ids-tabs-container.color-variant-header.rtl.is-scrolled-left::before {
  top: 0;
}
.ids-tabs-container:not(.orientation-vertical) {
  height: var(--ids-tab-height);
}
.ids-tabs-container:not(.orientation-vertical) .ids-tabs-list {
  width: var(--tab-width);
}
.ids-tabs-container.orientation-vertical {
  background-color: var(--ids-tab-vertical-color-background-default);
  border-inline-end: 1px solid var(--ids-tab-vertical-color-border-default);
  flex-direction: column;
  height: 100%;
  width: var(--vertical-container-width);
}
.ids-tabs-container.orientation-vertical .ids-tabs-list,
.ids-tabs-container.orientation-vertical .ids-tabs-list-more {
  flex-direction: column;
}
.ids-tabs-container.orientation-vertical ids-icon {
  margin-inline-end: 8px;
}
.ids-tabs-container.color-variant-header {
  height: var(--ids-tab-header-height);
  max-height: var(--ids-tab-header-height);
  min-height: var(--ids-tab-header-height);
}

.ids-tabs-list {
  flex-shrink: 1;
  overflow: auto;
  position: relative;
  scroll-behavior: smooth;
  display: flex;
  padding-inline-start: 0;
  margin-block-start: 0;
  margin-block-end: -1px;
  margin-inline-start: 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.ids-tabs-list::-webkit-scrollbar {
  display: none;
}

.ids-tabs-list-more {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  padding-inline-start: 0;
  margin-block-start: 0;
  margin-inline-start: 0;
}

.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) {
  margin-top: var(--ids-space-xs);
}

.ids-tabs-container:not(.orientation-vertical):not([class*=color-variant-]),
.ids-tabs-container.header-bottom-border:not(.orientation-vertical) {
  border-bottom: 1px solid var(--ids-tab-divider-color-background);
  height: unset;
  margin-top: 0;
}

.ids-tabs-container.color-variant-module {
  border-bottom: 1px solid var(--ids-tab-module-tab-color-border-bottom);
  height: var(--ids-tab-module-height);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
